import * as React from "react";

function Section1() {
  return (
    <div className="flex justify-center items-center px-16 py-14 bg-teal-50 max-md:px-5">
      <div className="justify-center w-full max-w-[1176px] max-md:max-w-full">
        <div className="flex gap-5 max-md:flex-col max-md:gap-0">
          <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
            <div className="flex flex-col grow justify-center self-stretch py-20 max-md:mt-10 max-md:max-w-full">
              <div className="text-4xl font-semibold text-cyan-700 max-md:max-w-full">
                <span className="font-extrabold">Power Your </span>
                <span className="font-extrabold text-cyan-700">Home</span>{" "}
                <span className="font-extrabold">with Solar Energy</span>
              </div>
              <div className="mt-4 text-lg leading-7 text-justify text-slate-700 max-md:max-w-full">
                Save Money and Reduce Your Carbon Footprint
              </div>
              <div className="justify-center self-start px-8 py-4 mt-8 text-sm font-bold text-white uppercase bg-cyan-700 rounded-lg max-md:px-5">
                Contact us
              </div>
            </div>
          </div>
          <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
            <div className="flex flex-col grow max-md:mt-10 max-md:max-w-full">
              <div className="max-md:max-w-full">
                <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                  <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
                    <div className="flex flex-col grow py-6 pr-6 pl-4 mx-auto w-full bg-white rounded-2xl max-md:pr-5 max-md:mt-6">
                      <div className="flex gap-2 text-xl font-bold text-blue-900">
                        <img
                          loading="lazy"
                          src="https://cdn.builder.io/api/v1/image/assets/TEMP/c4bb0984527c9f0bcc8afd1338f82fd1b1fd204022765f334a8dc357e56b3ee6?"
                          className="shrink-0 my-auto w-6 aspect-square"
                        />
                        <div>Reduce your electricity bills</div>
                      </div>
                      <div className="mt-4 text-sm leading-5 text-black">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Enim nisl.
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
                    <div className="flex flex-col grow items-start p-6 mx-auto w-full bg-white rounded-2xl max-md:px-5 max-md:mt-6">
                      <div className="flex gap-2 text-xl font-bold text-blue-900">
                        <img
                          loading="lazy"
                          src="https://cdn.builder.io/api/v1/image/assets/TEMP/1ee9fef8f5a7ba4ddf89887b7cc9017fcfe5ce750fbb58e3df3dc7f596c4cd46?"
                          className="shrink-0 my-auto w-6 aspect-square"
                        />
                        <div>
                          Cleaner future for <br />
                          next generations
                        </div>
                      </div>
                      <div className="mt-4 text-sm leading-5 text-black">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Enim nisl.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-6 max-md:max-w-full">
                <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                  <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
                    <div className="flex flex-col grow p-6 mx-auto w-full bg-white rounded-2xl max-md:px-5 max-md:mt-6">
                      <div className="flex gap-2 text-xl font-bold text-blue-900">
                        <img
                          loading="lazy"
                          src="https://cdn.builder.io/api/v1/image/assets/TEMP/cdeb148f04d685eaa11e85414fd2945d94bfe7c0e58e272cb0c910cdbf01c229?"
                          className="shrink-0 my-auto w-6 aspect-square"
                        />
                        <div>
                          Reduce your carbon <br />
                          footprints
                        </div>
                      </div>
                      <div className="mt-4 text-sm leading-5 text-black">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Enim nisl.
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
                    <div className="flex flex-col grow p-6 mx-auto w-full bg-white rounded-2xl max-md:px-5 max-md:mt-6">
                      <div className="flex gap-2 text-xl font-bold text-blue-900">
                        <img
                          loading="lazy"
                          src="https://cdn.builder.io/api/v1/image/assets/TEMP/41b53171436c54954c7e78148d9e7258654e77a6f0057825febb694df6e16842?"
                          className="shrink-0 my-auto w-6 aspect-square"
                        />
                        <div>
                          Enjoy your Solar <br />
                          Panels in your Roofs
                        </div>
                      </div>
                      <div className="mt-4 text-sm leading-5 text-black">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Enim nisl.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Section1;
